import React from 'react';
import PasswordChange from '../../Components/Common/PasswordChange';
import ManagerNavBar from '../../Components/NavigationBar/ManagerNavBar';
import Box from '@mui/material/Box';

const ManagerProfile = () => {
    return (
        <ManagerNavBar>
             <Box sx={{ width: '100%' }}>
         <PasswordChange></PasswordChange>
         </Box>
      </ManagerNavBar>
      );
};

export default ManagerProfile;